<template>
  <div class="Comments-List">
    <template v-if="get_isReady">
      <p class="Comments-List__ttl-separator" v-if="get_isShowLastCommentsTtl && get_pinnedComments.length > 0">Закрепленные комментарии</p>
      <CommentItem
        style="margin-top: 22px;"
        class="Comments-List__item"
        v-for="(comment, id, index) in get_pinnedComments"
        :key="comment.id"
        :comment="comment"
        :commentsPlace="commentsPlace"
        :context="props.context"
      />
      <p class="Comments-List__ttl-separator Comments-List__ttl-separator--last" v-if="get_isShowLastCommentsTtl">Последние комментарии</p>
      <CommentItem
        class="Comments-List__item"
        v-for="(comment, id, index) in get_comments"
        :style="getMargin(comment.level)"
        :key="comment.id"
        :comment="comment"
        :commentsPlace="commentsPlace"
        :context="props.context"
      />
      <div class="Comments-List__next-comment-ldr" v-if="get_isLoadingNewComments">
        <LoaderCircle :color="'var(--blue-600)'" :size="24" />
      </div>
    </template>
    <div class="Comments-List__ldr" v-else>
      <LoaderCircle :color="'var(--blue-600-s)'" :size="32" />
    </div>
  </div>
</template>

<script setup>
  import { defineProps, computed, onMounted, nextTick } from 'vue';
  import { Props } from './scripts/props.js';
  import { useStore } from 'vuex';
  //---------------------------
  import LoaderCircle from '@ui/Loaders/LoaderCircle/LoaderCircle.vue';
  import CommentItem from '@entities/Comments/CommentItem/CommentItem.vue';
  //---------------------------
  const props = defineProps(Props());
  const store = useStore();
  //---------------------------
  onMounted(async () => {
    await toLoadComments();
    await nextTick();
    goToTheComment();
  });
  //---------------------------
  //Получить контекст объекта для комментариев
  const get_commentsCtx = computed(() => {
    if(props.commentsPlace === 'popup') return 'popupComments';
    else if(props.commentsPlace === 'page') return 'contentPageComments';
  })
  //Готов ли список к отрисовке
  const get_isReady = computed(() => store.state.ContentSystem.Comments[get_commentsCtx.value].isReady);
  //Получить список комментариев
  const get_comments = computed(() => store.state.ContentSystem.Comments[get_commentsCtx.value].list);
  //Получить список комментариев
  const get_pinnedComments = computed(() => store.state.ContentSystem.Comments[get_commentsCtx.value].pinnedList);
  //Отображать ли заголовок последних комментариев?
  const get_isShowLastCommentsTtl = computed(() => get_comments.value?.length > 0);
  //Идет ли подгрузка новых комментов
  const get_isLoadingNewComments = computed(() => store.state.ContentSystem.Comments[get_commentsCtx.value].isLoadingNext);
  //---------------------------
  //Получить комментарии
  const toLoadComments = async () => {
    await store.dispatch('ContentSystem/Comments/startCommentsLoadingProcess',  {postId: props.postId, context: get_commentsCtx.value, area: props.context });
    return;
  }
  //Получить отступ коммента относительно его уровня вложенности
  const getMargin = (level) => {
    const levelNum = parseInt(level);
    return `
      margin-top: ${levelNum === 0 ? 22 : 10}px;
      margin-left: ${levelNum * 12}px;
    `;
  }
  //Проскролить к конкретному комментарию
  const goToTheComment = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const commentIdFromUrl = urlParams.get('comment_id');
    const idCommentScroll = store.state.ContentSystem.Comments[get_commentsCtx.value].targetCommentsId;
    const idToScroll = commentIdFromUrl || idCommentScroll;
    if(!idToScroll) return;
    await nextTick();
    const widget = document.querySelector('.Wdgt-Content') || document.querySelector('.Wdgt-Signal-Content');
    const comment = widget.querySelector(`[data-comment-id="${idToScroll}"]`);
    if (!comment) return;
    comment.scrollIntoView({
      behavior: 'auto',
      block: 'center'
    });
    store.commit('ContentSystem/Comments/setScrollTarget', {
      isComments: null,
      idComment: null,
      context: get_commentsCtx.value
    });
  }
</script>

<style lang="scss">
  @import './styles/_styles';
</style>
